import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const volumeAC: CriterionType[] = [
  {
    id: 'PV-20',
    label: 'Daily volume (% of shares o/s)',
    shortLabel: 'VolD%SO',
    group: AC_GROUPS.volume,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'PV-30',
    label: 'Monthly volume (% of shares o/s)',
    shortLabel: 'VolM%SO',
    group: AC_GROUPS.volume,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'PV-90_1d',
    label: 'Avg volume (1D) (M)',
    shortLabel: 'AvgVol1D',
    group: AC_GROUPS.volume,
    type: AC_TYPES.normal,
    timeOptions: ['1d'],
    withRange: true,
  },
  {
    id: 'PV-90_10d',
    label: 'Avg volume (10D) (M)',
    shortLabel: 'AvgVol10D',
    group: AC_GROUPS.volume,
    type: AC_TYPES.normal,
    timeOptions: ['10d'],
    withRange: true,
  },
  {
    id: 'PV-90_3m',
    label: 'Avg volume (3M) (M)',
    shortLabel: 'AvgVol3M',
    group: AC_GROUPS.volume,
    type: AC_TYPES.normal,
    timeOptions: ['3m'],
    withRange: true,
  },
];

export default volumeAC;
